import React, { useState, useEffect } from 'react';
import { Drawer, Button, Select, Input, Form, Spin, List, Space, message } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import FiltersDynamic from '../Components/FiltersDynamicComponent';
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';

const { Option } = Select;

const DecisionRecordFlowDrawer = ({selectedNode, visible, onClose, onSave, setNodeData, connectedNodes,nodeData,getRecordsData }) => {
  const [objects, setObjects] = useState([]);
  const [fields, setFields] = useState([]);
  const [selectedObject, setSelectedObject] = useState(null);
  const [loading, setLoading] = useState(false);
  const [valueOperator, setValueOperator] = useState('');
  // const [logic, setLogic] = useState('AND');
  // const [filters, setFilters] = useState([]);
  const [lookupOptions, setLookupOptions] = useState([]); 
  const [name, setName] = useState('');
  const [apiName, setApiName] = useState('');
  const [description, setDescription] = useState('');
  const [realFilters,setRealFitlers]=useState([]);

  // Outcome-related state
  const [outcomes, setOutcomes] = useState([{ 
    label: '', 
    apiName: '', 
    filters: [], 
    picklist: '', // Add picklist field to each outcome
    logic_string:''
  }]);
  const [selectedOutcomeIndex, setSelectedOutcomeIndex] = useState(0);

  useEffect(() => {
    if (visible) fetchObjects();
  }, [visible]);

  useEffect(() => {
    if (nodeData && Object.keys(nodeData).length > 0) {
      // Set basic details
      setName(nodeData.name || '');
      setApiName(nodeData.apiname || '');
      setDescription(nodeData.description || '');
      setSelectedObject(nodeData.parameters?.model || null);
      // Extract conditions
      const extractedOutcomes = nodeData.parameters?.conditions?.map((condition) => ({
        logic_string: condition.logic_string || "1", // Default to "1"
        label: condition.name || "", 
        apiName: condition.apiname || "", // Extract API Name if present
        picklist: condition.picklist || "", // Extract Picklist if present
        filters:displayFilters(condition)

      })) || [];
  
      
      // Store the conditions in state
      setOutcomes(extractedOutcomes);
      // Fetch fields for the selected object if available
      if (nodeData.parameters?.model) {
        fetchFields(nodeData.parameters.model);
      }
    } else {
      // Reset all states if nodeData is empty or null
      setName('');
      setApiName('');
      setDescription('');
      setSelectedObject(null);
      setValueOperator('');
      setSelectedOutcomeIndex(0);
      setLookupOptions([]);
      setOutcomes([{label: '', 
        apiName: '', 
        filters: [], 
        picklist: '', // Add picklist field to each outcome
        logic_string:''
      }]);
    }
  }, [nodeData]);

  const displayFilters=(condition)=>{
    
    const existingFilters = condition.conditions
    ? Object.entries(condition.conditions).map(([key, { field, value }]) => {
      let operator = '';
      let actualValue = '';
      if (Object.keys(value)[0] !== "0") {
        operator = Object.keys(value)[0];
        actualValue = value[operator];
      } else {
        actualValue = value; // Extract the actual value (e.g., '50')
      }
      let op = '';
      if (operator !== '') {
        try {
          setValueOperator(operator);
          op = operator
        } catch (error) {
          // Handle the error gracefully
          setValueOperator(''); // or any default value
        }
      } else {
        op = '';
      }
      return {
        field,
        value: value,
        displayValue: actualValue,
        operator: op
      };
    })
    : [{ field: '', value: '', operator: '' }]; 
    

    return existingFilters;
  }

  
    
  const fetchObjects = async () => {
    try {
      setLoading(true);
      const apiService = new ApiService(`${BASE_URL}/mt_objects`, { 'Content-Type': 'application/json' }, 'GET');
      const response = await apiService.makeCall();
      setObjects(response);
    } catch (error) {
      message.error('Failed to fetch objects.');
    } finally {
      setLoading(false);
    }
  };

  const fetchFields = async (objName) => {
    try {
      setLoading(true);
      const apiService = new ApiService(`${BASE_URL}/mt_fields/object/${objName}`, { 'Content-Type': 'application/json' }, 'GET');
      const response = await apiService.makeCall();
      setFields(response);
    } catch (error) {
      message.error('Failed to fetch fields.');
    } finally {
      setLoading(false);
    }
  };

  const handleAddOutcome = () => {
    setOutcomes([...outcomes, { label: '', apiName: '', filters: [], picklist: '',logic_string:'' }]);
    setSelectedOutcomeIndex(outcomes.length); // Automatically select the newly added outcome
  };

  const fetchLookupRecordsForExistingFilters = (existingFilters) => {
    existingFilters.forEach(filter => {
      const selectedField = fields.find(field => field.name === filter.field.replace('_id', ''));
      if (selectedField && selectedField.type === 'lookup') {
        fetchLookupRecords(selectedField.parent_object_name); // Fetch records for lookup fields
      }
    });
  };
  // Function to fetch records for the lookup field
  const fetchLookupRecords = async (objectName) => {
    try {
      const apiServiceForRecords = new ApiService(
        `${BASE_URL}/fetch_records/${objectName}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiServiceForRecords.makeCall();
      // Assuming response is an array of records with _id and Name fields
      const records = response?.records?.map(record => ({
        value: record._id, // Set _id as value
        label: record.Name, // Set Name as label
      }));
      setLookupOptions(records); // Set options for the lookup field
    } catch (error) {
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to save field due to an unknown error';
      message.error(errorMessage);
    }
  };

  const handleRemoveOutcome = (index) => {
    if (outcomes.length === 1) {
      message.error('At least one outcome is required.');
      return;
    }

    const updatedOutcomes = outcomes.filter((_, idx) => idx !== index);
    setOutcomes(updatedOutcomes);
    setSelectedOutcomeIndex(0); // Select the first outcome after deletion
  };

  const handleOutcomeChange = (field, value) => {
    const updatedOutcomes = [...outcomes];
    updatedOutcomes[selectedOutcomeIndex][field] = value;
    setOutcomes(updatedOutcomes);
  };

  const handleFilterChange = (filters) => {
    const updatedOutcomes = [...outcomes];
    updatedOutcomes[selectedOutcomeIndex].filters = filters;
    // updatedOutcomes[selectedOutcomeIndex].logic_string=logic;
    setOutcomes(updatedOutcomes);
  };

  const handleSave = () => {
    // Validate required fields
    if (!name || !apiName || outcomes.some((outcome) => !outcome.label || !outcome.apiName)) {
      message.error('Please fill all required fields for the decision and outcomes.');
      return;
    }
  
    // Transform outcomes' filters for backend
    // const updatedOutcomes = outcomes.map(({logic,...outcome}) => ({
    //   ...outcome,
    //   filters: outcome.filters.map((filter) => ({
    //     field: filter.field,
    //     value: filter.value,
    //   })), // Only send field and value to the backend

    // }));

    

    // const updatedOutcome = updatedOutcomes.map((outcome) => ({
    //   ...outcome,
    //   filters: outcome.filters.map(({ logic, ...filter }) => filter), // Remove the logic property
    // }));
    const type = 'Decision';
    const data = {
      name,
      apiName,
      description,
      selectedObject,
      outcomes: outcomes,
      type
    };
  
    // Save data to parent
    onSave(selectedNode.id, data);
    message.success('Decision Record saved successfully!');
    onClose();
  };

  const handleCancel =()=>{
    setSelectedOutcomeIndex(0);
    onClose();
  }
  const handleLogicChange = (logic) => {
    const updatedOutcomes = [...outcomes];
    updatedOutcomes[selectedOutcomeIndex].logic = logic;
    updatedOutcomes[selectedOutcomeIndex].logic_string=logic;
    setOutcomes(updatedOutcomes);
  };

  return (
    <Drawer
      title="Decision Records"
      placement="right"
      zIndex={1002}   // higher than sidebar
      onClose={handleCancel}
      visible={visible}
      width={800}
      footer={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={handleSave}>Save</Button>
        </div>
      }
    >
      {loading ? (
        <Spin tip="Loading..." />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          {/* Decision-Level Fields */}
          <Form layout="vertical">
            <Form.Item label="Decision Label" required>
              <Input
                placeholder="Enter Decision Label"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onBlur={() => {
                  if (name) {
                    setApiName(
                      name
                        .replace(/[^a-zA-Z0-9]/g, "") // Remove special characters
                        .replace(/\s+/g, "") // Remove spaces
                        .trim()
                    );
                  }
                }}            
              />
            </Form.Item>

            <Form.Item label="Decision API Name" required>
              <Input
                placeholder="Enter Decision API Name"
                value={apiName}
                onChange={(e) => setApiName(e.target.value)}
              />
            </Form.Item>

            <Form.Item label="Description">
              <Input.TextArea
                placeholder="Enter Description"
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Form.Item>

            <Form.Item label="Select Object" required>
              <Select
                placeholder="Select Object"
                style={{ width: '100%' }}
                onChange={(value) => {
                  setSelectedObject(value);
                  fetchFields(value);
                }}
                value={selectedObject}
              >
                {objects.map((obj) => (
                  <Option key={obj.name} value={obj.name}>
                    {obj.label || obj.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>

          {/* Outcomes Section */}
          <div style={{ display: 'flex', flexGrow: 1, marginTop: 16 }}>
            {/* Left Sidebar: Outcome List */}
            <div style={{ width: '30%', borderRight: '1px solid #f0f0f0', paddingRight: 16 }}>
              <Button
                type="dashed"
                icon={<PlusOutlined />}
                style={{ width: '100%', marginBottom: 16 }}
                onClick={handleAddOutcome}
              >
                Add Outcome
              </Button>
              <List
                dataSource={outcomes}
                renderItem={(item, index) => (
                  <List.Item
                    key={index}
                    style={{
                      background: index === selectedOutcomeIndex ? '#f5f5f5' : 'transparent',
                      cursor: 'pointer',
                    }}
                    onClick={() => setSelectedOutcomeIndex(index)}
                  >
                    <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                      <span>{item.label || `Outcome ${index + 1}`}</span>
                      <DeleteOutlined
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveOutcome(index);
                        }}
                        style={{ color: 'red' }}
                      />
                    </Space>
                  </List.Item>
                )}
              />
            </div>

            {/* Right Panel: Outcome Details */}
            <div style={{ width: '70%', paddingLeft: 16 }}>
              <Form layout="vertical">
                <Form.Item label="Outcome Label" required>
                  <Input
                    placeholder="Enter Outcome Label"
                    value={outcomes[selectedOutcomeIndex]?.label}
                    onChange={(e) => handleOutcomeChange('label', e.target.value)}
                  />
                </Form.Item>

                <Form.Item label="Outcome API Name" required>
                  <Input
                    placeholder="Enter Outcome API Name"
                    value={outcomes[selectedOutcomeIndex]?.apiName}
                    onChange={(e) => handleOutcomeChange('apiName', e.target.value)}
                  />
                </Form.Item>

                <Form.Item label="Picklist" required>
                  <Select
                    value={outcomes[selectedOutcomeIndex]?.picklist}
                    onChange={(value) => handleOutcomeChange('picklist', value)}
                  >
                    <Option value="Decision">Decision</Option>
                    <Option value="Get Records">Get Records</Option>
                    <Option value="Update Records">Update Records</Option>
                    <Option value="Delete Records">Delete Records</Option>
                    <Option value="Create Records">Create Records</Option>
                    <Option value="Loop">Loop</Option>
                  </Select>
                </Form.Item>

                <Form.Item label="Conditions">
                  <FiltersDynamic
                    fields={fields}
                    lookupOptions={lookupOptions}
                    filters={outcomes?.[selectedOutcomeIndex]?.filters}
                    setFilters={handleFilterChange}
                    logic={outcomes?.[selectedOutcomeIndex]?.logic ?? outcomes?.[selectedOutcomeIndex]?.logic_string}
                    setLogic={handleLogicChange}
                    valueOperator={valueOperator}
                    setValueOperator={setValueOperator}
                    fetchLookupRecordsForExistingFilters={fetchLookupRecordsForExistingFilters}
                    fetchLookupRecords={fetchLookupRecords}
                  />
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      )}
    </Drawer>
  );
};

export default DecisionRecordFlowDrawer;

